import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import ModalAlunoMateriasAcoes from './ModalAlunoMateriasAcoes';

class TeamTrainingMatterStaffAcoesLinha extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      team_training_matter_staff_id: this.props.team_training_matter_staff_id,
      result: this.props.result,
      imported_str: this.props.imported_str,
      status_str: this.props.status_str,
      exam_applied_start_str: this.props.exam_applied_start_str,
      exam_applied_finish_str: this.props.exam_applied_finish_str,
      team_training_matter_staff_exam_id: this.props.id,
    };
    this.export = this.export.bind(this);
  }
  export(event) {
    var self = this;
    self.props.handleAlert('', '', 'open');
    var team_training_matter_staff_exam_id = event.currentTarget.value;
    var url = "/exportar/resultado/prova/" + team_training_matter_staff_exam_id;
    var header = this.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
        self.props.handleAlert('', '', 'closed');
      });
    });
  }
  render() {
    var self = this;
    return (
      <tr>
        <td>{this.state.result}</td>
        <td>{this.state.status_str}</td>
        <td>{this.state.exam_applied_start_str} - {this.state.exam_applied_finish_str}</td>
        <td>{this.state.imported_str}</td>
        <td><button className="btn btn-info btn-xs" value={this.state.team_training_matter_staff_exam_id} onClick={self.export}><i className="fa fa-fw fa-download"></i></button></td>
      </tr>        
    );
  }
}

export default TeamTrainingMatterStaffAcoesLinha;



// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/TeamTrainingMatterStaffAcoesLinha.js